//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SPage from '~/components/page/SPage.vue'

import SpecialistHeader from '~/pages/specialists/components/Header/SpecialistHeader.vue'
import SpecialistCard from '~/pages/specialists/components/SpecialistCard.vue'
import AppointmentModal from '~/components/appointment/AppointmentModal.vue'
import {
  AppMixin,
  CmsMetaMixin,
} from '~/node_modules/sitis-nuxt/lib/mixins/index'

export default {
  name: 'SpecialistsPage',

  head: function () {
    const head = {
      title: this.headTitle,
      meta: [
        {
          hid: 'metadescription',
          name: 'description',
          content: this.headDescription
        },
        {
          name: 'keywords',
          content: this.headKeywords
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://linza.ru/storage/0_logo-linza_fc99a32e.svg',
        },

        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content: 'Очки Для Вас',
        },

        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://${this.host}${this.$route.fullPath}`,
        },
      ],
    }

    return head
  },

  components: {
    SPage,

    SpecialistHeader,
    SpecialistCard,
    AppointmentModal,
  },

  async asyncData ({
    $api,
    params,
    req
  }) {
    let cities = []
    let storesList = []
    const host = req?.headers?.host || window?.location.host || ''
    const { data: specialists } = await $api.agent.transport.get(
      'specialist?expand=stores'
    )

    specialists.map((specialist) => {
      const stores = specialist.stores
      stores.map((store) => {
        if (!storesList.find((t) => t.value === store.id)) {
          storesList.push({
            label: store.address,
            value: store.id,
            city: store.city_name,
          })
        }

        if (!cities.find((t) => t.value === store.city_id)) {
          cities.push({
            label: store.city_name,
            value: store.city_id,
          })
        }
      })
    })
    return {
      host,
      specialists,
      cities,
      storesList,
      userId: params.id || '',
    }
  },

  mixins: [
    AppMixin
  ],

  data () {
    return {
      breadcrumbs: [{
        path: '/',
        title: 'Главная'
      }, {
        path: '/specialists',
        title: 'Наши специалисты'
      }],

      activeCity: {
        label: 'Екатеринбург',
        value: 1
      },
      activeStore: null,
      isOpen: false,
      userId: '',
      workWithChildren: false,
    }
  },

  mounted () {
    const activeCityName = this.appCfg?.city?.model?.name || 'Екатеринбург'
    const activeCity = this.cities.find((t) => t.label === activeCityName)

    this.activeCity = activeCity
  },

  computed: {
    setCityName () {
      this.activeStore = null
      const cities = this.cities
      if (!this.activeCity) {
        return 'Выберите город'
      }
      // console.log(this.activeCity);
      return cities.find((city) => city.value == this.activeCity?.value).label
    },
    setStoreAddress () {
      const storesList = this.storesList
      if (!this.activeStore) {
        return 'Выберите салон'
      }
      if (this.activeStore === 'Все салоны') {
        this.activeStore = ''
        return 'Все салоны'
      }
      return storesList.find((store) => store.value == this.activeStore?.value)
        .label
    },
    getStoreAddressInCity () {
      const storesList = this.storesList
      return storesList.filter(
        (address) => address.city == this.activeCity?.label
      )
    },
    specialistFilter () {
      const activeStore = this.activeStore
      const activeCity = this.activeCity
      const workWithChildren = this.workWithChildren
      const specialists = [...this.specialists]

      return specialists.filter((specialist) => {
        const userActiveCity = Boolean(activeCity) ? Boolean(specialist.stores.find((t) => t.city_id === activeCity.value)) : true
        const userActiveStore = Boolean(activeStore) ? Boolean(specialist.stores.find((t) => t.id === activeStore.value)) : true
        const userWorkChildren = Boolean(workWithChildren) ? Boolean(specialist.for_children) : true

        if (userActiveCity && userActiveStore && userWorkChildren) {
          return specialist
        }
      })
    },

    headTitle: function () {
      const defaultTitle = 'Наши специалисты'

      if (!this.userId) {
        return defaultTitle
      }

      return (this.specialists || []).find((t) => +t.id === +this.userId)?.seo_title || defaultTitle
    },
    headKeywords: function () {
      const defaultTitle = 'Наши специалисты'

      if (!this.userId) {
        return defaultTitle
      }

      return (this.specialists || []).find((t) => +t.id === +this.userId)?.seo_keywords || defaultTitle
    },
    headDescription: function () {
      const defaultDescription = 'Раздел «Наши специалисты». Есть вопросы? Звоните: 8 (800) 302-34-45.'

      if (!this.userId) {
        return defaultDescription
      }

      return (this.specialists || []).find((t) => +t.id === +this.userId)?.seo_description || defaultDescription
    },
  },

  methods: {
    openModal (id) {
      this.userId = String(id)
    },
    closeModal () {
      this.userId = ''
    },
    onChangeFilter ({
      name,
      value
    }) {
      const newFilter = { ...this.filter }
      newFilter[name] = value

      this.filter = newFilter

      // вызов метода обновления сотрудников
    },
  },
}
